import React, { useRef, useEffect } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";

const CrmFeedbackSection = () => {
  const feedbackData = [
    {
      quote:
        "Senertech has been an invaluable partner in helping us navigate the complex world of IT. Their team of experts provided us with insightful consultations, tailored solutions, and ongoing support. Thanks to their guidance, we've been able to streamline our operations and improve our overall efficiency.",
      author: "Sumit Goswami",
      rating: 5,
      tag: "Satisfied IT Consultant Client",
    },
    {
      quote:
        "We were struggling to increase our online visibility until we partnered with Senertech. Their digital marketing strategies have been incredibly effective. Our website traffic has skyrocketed, and we've seen a significant boost in leads and sales. I highly recommend them! ",
      author: "Shivam Chaudhary",
      rating: 5,
      tag: "Happy Digital Marketing Client",
    },
    {
      quote:
        "Senertech has taken our social media presence to the next level. Their team is always up-to-date on the latest trends and knows how to create engaging content that resonates with our target audience. We've seen a significant increase in engagement and brand awareness thanks to their expertise.  ",
      author: "Karan Chaurasia",
      rating: 5,
      tag: "Delighted Social Media Management Client",
    },
    {
      quote:
        "We needed professional videos to showcase our products, and Senertech delivered beyond our expectations. Their team was creative, efficient, and easy to work with. The final videos were of exceptional quality and helped us attract new customers.  ",
      author: "Radha Mathur",
      rating: 5,
      tag: "Thrilled Video Production Client",
    },
    {
      quote:
        "Senertech's graphic design team has a knack for creating visually stunning designs that capture the essence of our brand. They've helped us revamp our website, create marketing materials, and develop a consistent brand identity. We're extremely satisfied with their work.",
      author: "Anjali Sharma",
      rating: 5,
      tag: "Impressed Graphic Design Client",
    },
    // Add more feedback items as needed
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  // Use useEffect to ensure Swiper navigation updates once refs are ready
  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section className="crm-feedback-section p-50 mt-3 overflow-hidden bg-white">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="crm-feedback-box rounded position-relative">
              {/* Feedback Slider */}
              <Swiper
                modules={[Navigation, Pagination]}
                className="crm-feedback-slider swiper"
                slidesPerView={1}
                loop={true}
                speed={800}
                spaceBetween={24}
                autoplay={{ delay: 5000 }}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper; // Store swiper instance for use in useEffect
                }}
                // pagination={{ clickable: true }} 
                // Optional: Enable pagination
              >
                {feedbackData.map((f, index) => (
                  <SwiperSlide
                    key={index}
                    className="crm-feedback-single swiper-slide text-center"
                  >
                    {/* <h5 className="mb-2 text-white">{f.tag}</h5> */}
                    <p className="mb-4 text-white">{f.quote}</p>
                    <h4 className="mb-0 text-white">{f.author}</h4>
                    <ul className="crm-stars d-inline-flex align-items-center p-0 m-0">
                      {Array(5)
                        .fill()
                        .map((_, starIndex) => (
                          <li key={starIndex} className="list-inline">
                            <i className="fa-solid fa-star"></i>
                          </li>
                        ))}
                    </ul>
                  </SwiperSlide>
                ))}
              </Swiper>
              {/* Navigation Controls */}
              <div
                ref={prevRef}
                className="crm-prev-control-outer crm-fd-slide-control"
              >
                <i className="fa-solid fa-arrow-left"></i>
              </div>
              <div
                ref={nextRef}
                className="crm-next-control-outer crm-fd-slide-control"
              >
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CrmFeedbackSection;
